// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friends-positions__answer{display:inline-block;margin-top:1em;margin-right:.75em;font-size:.75em}", ""]);
// Exports
module.exports = exports;
